import React, {ReactElement} from 'react';
import IconWrapper, {IconProps} from '../IconWrapper';

export function Clarity(props: IconProps): ReactElement {
  return (
    <IconWrapper {...props} viewBox="0 0 48 48">
      <circle cx="16.9459" cy="28.9459" r="13.9459" fill="#A67DFB" />
      <path
        d="M32.1795 21.7352C33.1206 31.9914 21.4531 32.4616 21.4531 32.4616V11.0088C21.4531 11.0088 31.3327 12.1379 32.1795 21.7352Z"
        fill="#80D7FD"
      />
      <path
        d="M21.4526 33.4964C14.9603 33.4964 9.69141 28.2274 9.69141 21.7353C9.69141 15.2431 14.9604 9.97412 21.4526 9.97412C27.9447 9.97412 33.2137 15.2431 33.2137 21.7353C33.2137 28.2274 27.9447 33.4964 21.4526 33.4964ZM21.4526 11.8557C15.9951 11.8557 11.573 16.2779 11.573 21.7353C11.573 27.1927 15.9951 31.6149 21.4526 31.6149C26.91 31.6149 31.3321 27.1927 31.3321 21.7353C31.3321 16.2779 26.91 11.8557 21.4526 11.8557Z"
        fill="#202020"
      />
      <path
        d="M21.4527 6.21003C20.9824 6.21003 20.5117 5.83355 20.5117 5.26901V0.94102C20.5117 0.470672 20.8882 0 21.4527 0C22.0173 0 22.3938 0.376473 22.3938 0.94102V5.26933C22.3938 5.83356 21.9231 6.21003 21.4527 6.21003Z"
        fill="#202020"
      />
      <path
        d="M21.4527 42.9999C20.9824 42.9999 20.5117 42.6234 20.5117 42.0589V37.7306C20.5117 37.2602 20.8882 36.7896 21.4527 36.7896C22.0173 36.7896 22.3938 37.166 22.3938 37.7306V42.0589C22.3938 42.5292 21.9231 42.9999 21.4527 42.9999Z"
        fill="#202020"
      />
      <path
        d="M42.0594 22.6765H37.7311C37.2607 22.6765 36.79 22.301 36.79 21.7355C36.79 21.2651 37.1665 20.7944 37.7311 20.7944H42.0594C42.5297 20.7944 43.0004 21.1709 43.0004 21.7355C43.0004 22.2058 42.5297 22.6765 42.0594 22.6765Z"
        fill="#202020"
      />
      <path
        d="M5.26901 22.6765H0.941021C0.470672 22.6765 0 22.301 0 21.7355C0 21.2651 0.376473 20.7944 0.941021 20.7944H5.26933C5.73968 20.7944 6.21035 21.1709 6.21035 21.7355C6.21003 22.2058 5.83356 22.6765 5.26901 22.6765Z"
        fill="#202020"
      />
      <path
        d="M36.0371 37.1658C35.7549 37.1658 35.5668 37.0707 35.3784 36.8836L32.3676 33.8727C31.9921 33.4963 31.9921 32.9317 32.3676 32.5556C32.7441 32.18 33.3086 32.18 33.6847 32.5556L36.6956 35.5664C37.0711 35.9429 37.0711 36.5074 36.6956 36.8836C36.5078 37.0719 36.2255 37.1658 36.0371 37.1658H36.0371Z"
        fill="#202020"
      />
      <path
        d="M10.0673 11.1963C9.785 11.1963 9.59693 11.1021 9.40853 10.9141L6.30384 7.90324C5.92737 7.52676 5.92737 6.96222 6.30384 6.58607C6.68031 6.20959 7.24486 6.20959 7.62101 6.58607L10.6318 9.59688C11.0083 9.97335 11.0083 10.5379 10.6318 10.9141C10.5379 11.1024 10.2557 11.1963 10.0673 11.1963Z"
        fill="#202020"
      />
      <path
        d="M32.9323 11.1031C32.65 11.1031 32.462 11.0089 32.2736 10.8208C31.8971 10.4443 31.8971 9.87977 32.2736 9.50362L35.2844 6.4928C35.6599 6.11633 36.2254 6.11633 36.6006 6.4928C36.9771 6.86928 36.9771 7.43382 36.6006 7.80997L33.5911 10.8208C33.403 11.0089 33.1207 11.1031 32.9323 11.1031Z"
        fill="#202020"
      />
      <path
        d="M6.96259 37.1658C6.68031 37.1658 6.49224 37.0707 6.30384 36.8836C5.92737 36.5071 5.92737 35.9425 6.30384 35.5664L9.31465 32.5556C9.69113 32.18 10.2557 32.18 10.6318 32.5556C11.0083 32.932 11.0083 33.4966 10.6318 33.8727L7.62101 36.8836C7.43325 37.0719 7.15097 37.1658 6.96258 37.1658H6.96259Z"
        fill="#202020"
      />
    </IconWrapper>
  );
}
